import {IntermediatePart} from "../../intermediatePart";
import Walls from "../../parts/walls";

export default class ShowerScreen extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_screen';
    this.partName = 'Shower Screen';
    this.translateId = "visualizer.bathroom.shower.shower_screen";
    this.layerPriority = 12;
    this.canBeDisabled = true;
  }

  handleClick() {
    const wallParent = this.getParent().getParent().layout.parts[Walls.id];
    if (wallParent && wallParent.splitWall) {
      wallParent.splitWall.disabled = true;
    }
    super.handleClick();
  }

  setLayers(layout) {
    const wallParent = layout.parts[Walls.id];
    if (wallParent && wallParent.splitWall && wallParent.splitWall.activeFeature && !wallParent.splitWall.disabled) {
      super.hideLayers();
      return;
    }
    return super.setLayers(layout);
  }

}
